<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                      <div align='center'>{{labels.tableTitle}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-data-table :headers="headers" :items="riskList" class="elevation-1" >
                      <template slot="no-data">
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs4>
                    <v-autocomplete v-model="mainForm.tariff" :label="labels.tariff" item-text="tariff" item-value="tariff" data-vv-name="tariff" :data-vv-as="labels.tariff" :error-messages="errors.collect('tariff')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model="mainForm.search" :label="labels.search" :error-messages="errors.collect('search')" data-vv-name="search" :data-vv-as="labels.search">
                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                        <v-icon color="info" v-text="'mdi-magnify'"></v-icon>
                      </v-slide-x-reverse-transition>
                    </v-text-field>
                  </v-flex>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-card-title>
                <div class="body-2">{{labels.titleDet}}</div>
              </v-card-title>
                <v-layout row wrap>
                  <v-flex xs5>
                       <v-text-field v-model="mainForm.tariff" :label="labels.tariff" :error-messages="errors.collect('tariff')" data-vv-name="tariff" :data-vv-as="labels.tariff">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                  </v-flex>
                  <v-flex xs7>
                    <v-text-field ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                       <v-text-field v-model="mainForm.benCode" :label="labels.benCode" :error-messages="errors.collect('benCode')" data-vv-name="benCode" :data-vv-as="labels.benCode">
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                  </v-flex>
                  <v-flex xs7>
                    <v-text-field ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <cal-picker v-model="mainForm.effDate" :label="labels.effDate"></cal-picker>
                  </v-flex>
                  <v-flex xs7>
                  </v-flex>
                  <v-flex xs5>
                    <v-checkbox v-model="mainForm.includeBCls" :label="labels.includeBCls"></v-checkbox>
                  </v-flex>
                   <v-flex xs7>
                  </v-flex>
                  <v-flex xs5>
                    <v-checkbox v-model="mainForm.inludeCoverType" :label="labels.inludeCoverType"></v-checkbox>
                  </v-flex>
                  <v-flex xs7>
                  </v-flex>
                  <v-flex xs7>
                    <v-autocomplete v-model="mainForm.tariffKeyA" :label="labels.tariffKeyA" item-text="tariffKeyA" item-value="tariffKeyA" data-vv-name="tariffKeyA" :data-vv-as="labels.tariffKeyA" :error-messages="errors.collect('tariffKeyA')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs5>
                  </v-flex>
                  <v-flex xs7>
                    <v-autocomplete v-model="mainForm.tariffKeyB" :label="labels.tariffKeyB" item-text="tariffKeyB" item-value="tariffKeyB" data-vv-name="tariffKeyB" :data-vv-as="labels.tariffKeyB" :error-messages="errors.collect('tariffKeyB')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs5>
                  </v-flex>
                  <v-flex xs5>
                    <v-autocomplete v-model="mainForm.basedOnUOM" :label="labels.tariffKeyB" item-text="basedOnUOM" item-value="basedOnUOM" data-vv-name="basedOnUOM" :data-vv-as="labels.basedOnUOM" :error-messages="errors.collect('basedOnUOM')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs7>
                  </v-flex>
                  <v-flex xs5>
                    <v-autocomplete v-model="mainForm.napSubTotal" :label="labels.napSubTotal" item-text="napSubTotal" item-value="napSubTotal" data-vv-name="napSubTotal" :data-vv-as="labels.napSubTotal" :error-messages="errors.collect('napSubTotal')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs7>
                  </v-flex>
                  <v-flex xs5>
                    <v-autocomplete v-model="mainForm.gapCalMethod" :label="labels.gapCalMethod" item-text="gapCalMethod" item-value="gapCalMethod" data-vv-name="gapCalMethod" :data-vv-as="labels.gapCalMethod" :error-messages="errors.collect('gapCalMethod')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs7>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field v-model="mainForm.createdBy" :label="labels.createdBy" :error-messages="errors.collect('createdBy')" data-vv-name="createdBy" :data-vv-as="labels.createdBy"></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field v-model="mainForm.interest" :label="labels.interest" :error-messages="errors.collect('interest')" data-vv-name="interest" :data-vv-as="labels.interest"></v-text-field>
                  </v-flex>
                </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labels: {
        tableTitle: 'Motor Benefit Listss',
        searchBy: 'Search By',
        tariff: 'Tariff',
        titleDet: 'Details',
        search: 'Search',
        benCode: 'Benefit Code',
        effDate: 'Effective Date',
        includeBCls: 'Include Business class in Tariff Key',
        inludeCoverType: 'Include Cover Type in Tariff key',
        tariffKeyA: 'Tariff Key A Variable',
        tariffKeyB: 'Tariff Key B Variable',
        basedOnUOM: 'Based on UOM',
        napSubTotal: 'NAP SubTotal Level',
        gapCalMethod: 'GAP Calculation Method',
        createdBy: 'Created By',
        modifiedBy: 'Modified By'
      },
      mainForm: {
        tariff: undefined
      },
      headers: [
        { text: 'Tariff', align: 'left', value: 'listTariff' },
        { text: 'Benefit', value: 'listBenefit' },
        { text: 'Effective Date', value: 'listEffDate' },
        { text: 'GAP Method', value: 'listGapMethod' },
        { text: 'NAP Level', value: 'listNapLvl' }
      ]
    }
  }
}
</script>
